import { Text, tokens } from "@fluentui/react-components";
import { Flex } from "@/components/atoms/flex";
import { useTableStyle } from "@/components/atoms/customTable";
import TooltipWithMount from "@/components/atoms/tooltipWithMount/TooltipWithMount";
import { StatusCellProps } from "./types";

export const StatusCell = (props: StatusCellProps) => {
	const tableClasses = useTableStyle();

	return (
		<Flex style={{ minWidth: "80px" }}>
			<Flex column className={tableClasses.textContainerWithoutPadding}>
				<Flex
					style={{
						fontWeight: tokens.fontWeightSemibold,
						color: tokens.colorNeutralForeground1,
					}}
				>
					{props.timer}
				</Flex>
				<Flex>
					<TooltipWithMount
						key={"below"}
						withArrow
						positioning={"below"}
						content={{
							children: props.status ?? "",
							className: tableClasses.tooltip,
						}}
						relationship="label"
					>
						<Text className={tableClasses.ellipsis}>{props.status}</Text>
					</TooltipWithMount>
				</Flex>
			</Flex>
		</Flex>
	);
};
